import { render, staticRenderFns } from "./cg-form.vue?vue&type=template&id=591842b6&"
import script from "./cg-form.vue?vue&type=script&lang=js&"
export * from "./cg-form.vue?vue&type=script&lang=js&"
import style0 from "./cg-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports